import { Component, inject } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-confirm-year-modal',
	templateUrl: './confirm-year-modal.component.html',
	styleUrls: ['./confirm-year-modal.component.scss'],
	standalone: false,
})
export class ConfirmYearModalComponent {
	private translate = inject(TranslateService);
	private modalCtrl = inject(ModalController);

	public selectedLanguage: string;
	public canDrinkCheckbox: boolean = false;
	public minimumAge: number = 18;

	constructor() {
		this.selectedLanguage = this.translate.currentLang;
		this.setMinimumAge();
	}

	private setMinimumAge(): void {
		// Set minimum drinking age based on language/country
		const ageByLanguage: { [key: string]: number } = {
			en: 21, // English - defaulting to 21 (US standard)
			de: 18, // German - Germany
			fr: 18, // French - France
			es: 18, // Spanish - Spain
			pt: 18, // Portuguese - Portugal
		};

		this.minimumAge = ageByLanguage[this.selectedLanguage] || 18;
	}

	static async show(modalCtrl: ModalController): Promise<boolean> {
		const modal = await modalCtrl.create({
			component: ConfirmYearModalComponent,
			cssClass: 'auto-height confirm-year-modal',
			showBackdrop: true,
			backdropDismiss: true,
		});
		await modal.present();
		const result = (await modal.onDidDismiss()).data;
		return result;
	}

	dismissWithData() {
		this.modalCtrl.dismiss(this.canDrinkCheckbox);
	}

	dismiss() {
		this.modalCtrl.dismiss();
	}
}
